<div mat-dialog-title>
  <div class="w-100">
    <div class="d-flex">
      {{patient.nameSurname + ' '}}  <span class="ml-3" [class]="patient.sex =='M' ? 'icon-male' : patient.sex =='F'? 'icon-female': 'icon-neutral'" ></span>

      <div class="spacer"></div>
      <span class="mr-3" style="font-size: 0.75em; white-space: pre-wrap;"> <span class="bold">Protocolo:</span> {{data.order_id}}</span>
      <button mat-mini-fab color="warn" class="close-button" mat-dialog-close>
        <mat-icon class="close-icon">close</mat-icon>
      </button>    
    </div>
    <div class="d-flex flex-wrap" style="font-size: 0.75em; white-space: pre-wrap;">
      <span *ngIf="patient.birthdate" class="bold">Edad:</span> <span [matTooltip]="patient.birthdate" class="mr-3">{{' '+patient.age}}</span>
      <span *ngIf="patient.fiscalCode" class="bold">DNI:</span> <span class="ml-1 mr-3">{{patient.fiscalCode}}</span>
      <span *ngIf="patient.healthCode" class="bold">{{env.hc_label}}:</span> <span class="ml-1 mr-3" >{{patient.healthCode}}</span> 
      <div class="spacer"></div>
      <span style="margin-right: 2.5rem!important;"><span class="bold">Fecha:</span> {{data.order_date}}</span>
    </div>
  </div>


</div>
<div mat-dialog-content>
      <!--div style="height: 75vh; overflow-y: scroll;"-->
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Examen</th>
              <th scope="col"></th>
              <th scope="col">Resultado</th>
              <ng-container *ngIf="data.state > 4">
                <th scope="col">U.M.</th>
                <th scope="col">V.Ref.</th>
                <th scope="col">Validado por</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let result of filteredResults">
              <ng-container *ngIf="result.tests.length == 1">
                <tr>
                  <th>{{ result.tests[0].testDescription }}</th>
                  <td style="padding: 0;"> 
                    <button mat-icon-button  *ngIf="group.previousResults && result.tests[0].previousResultsGraph == -1"
                    (click)="getPreviousResults(result.tests[0])">
                      <mat-icon>assessment</mat-icon>
                    </button>
                  </td>
                  <td>{{ result.tests[0].result || result.note }}</td>

                  <ng-container *ngIf="data.state > 4">
                    <td>{{ result.tests[0].measureUnit }}</td>
                    <td>
                      <span *ngIf="result.tests[0].referenceValueMin !=null && result.tests[0].referenceValueMax  !=null">
                        {{ result.tests[0].referenceValueMin + ' - ' + result.tests[0].referenceValueMax }}
                      </span>
                    </td>
                    <td>{{ result.tests[0].validationUser }}</td>
                  </ng-container>
                </tr>
                <ng-container *ngFor="let micro of result.tests[0].micro">
                  <tr>

                    <td class="bold font-italic text-center" colspan="5">{{micro.result}}
                      
                    </td>
                  </tr>
                  <tr *ngIf="micro.anti.length > 0">
                    <td colspan="5">
                      <table class="table table-bordered table-sm">
                        <tr *ngFor="let atb of micro.anti">
                          <td class="pl-4">{{atb.testDescription}}</td>
                          <td style="max-width:20px;">{{atb.result}}</td>
                          <td style="max-width:200px;">{{atb.note}}</td>
                        </tr>
                      </table>
                    </td>                      
                  </tr>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="result.tests.length > 1">
                <tr>
                  <th colspan="6">{{result.rootDescription}}</th>
                </tr>
                <ng-container *ngFor="let test of result.tests">
                  <tr>
                    <td class="pl-4">{{ test.testDescription }}</td>
                    <td style="padding: 0;"> 
                      <button mat-icon-button  *ngIf="group.previousResults && result.tests[0].previousResultsGraph == -1"
                        (click)="getPreviousResults(test)">
                        <mat-icon>assessment</mat-icon>
                      </button>
                    </td>
                    <td>{{ test.result || result.note }}</td>
                    <ng-container *ngIf="data.state > 4">
                      <td>{{ test.measureUnit }}</td>
                      <td>{{ test.referenceValueMin + ' - ' + test.referenceValueMax }}</td>
                      <td>{{ test.validationUser }}</td>
                    </ng-container>
                  </tr>

                  <ng-container *ngFor="let micro of test.micro">
                    <tr>

                      <td class="bold font-italic text-center" colspan="5">{{micro.result}}
                        
                      </td>
                    </tr>
                    <tr *ngIf="micro.anti.length > 0">
                      <td colspan="5">
                        <table class="table table-bordered table-sm">
                          <tr *ngFor="let atb of micro.anti">
                            <td class="pl-4">{{atb.testDescription}}</td>
                            <td style="max-width:20px;">{{atb.result}}</td>
                            <td style="max-width:200px;">{{atb.note}}</td>
                          </tr>
                        </table>
                      </td>                      
                    </tr>
                  </ng-container>
                  
                </ng-container>
              </ng-container>
            </ng-container>
          
          </tbody>
        </table>
  

</div>

<mat-dialog-actions align="center">
  <mat-chip-list aria-label="Fish selection">
    <mat-chip *ngFor="let group of groupsId"
    (click)="filterResults(group)"
    color="primary" [style]="isSelected(group) ? 'background-color: #3f51b5;color: #fff;':''">
    {{group}}
  </mat-chip>
  </mat-chip-list>
</mat-dialog-actions>